import { useId } from 'react';
import { cn } from '@/lib/cn';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  hint?: string;
}

export const Input = ({ label, error, hint, className, ...props }: InputProps) => {
  const id = useId();

  return (
    <div className="flex flex-col gap-1.5">
      {label && (
        <label htmlFor={id} className="text-label font-medium text-neutral">
          {label}
        </label>
      )}
      <input
        id={id}
        className={cn(
          'rounded-control border bg-surface px-3 py-2.5 text-body text-ink transition-colors placeholder:text-muted hover:border-brand disabled:cursor-not-allowed disabled:bg-page disabled:text-muted',
          error ? 'border-bad' : 'border-line-strong',
          className
        )}
        {...props}
      />
      {error && <span className="text-label text-bad">{error}</span>}
      {hint && !error && <span className="text-label text-muted">{hint}</span>}
    </div>
  );
};
